export const GET_ALLOCATORS_DETAIL = "ALLOCATOR@GET_ALLOCATORS_DETAIL";
export const GET_ALLOCATORS_DETAIL_INIT =
  "ALLOCATOR@GET_ALLOCATORS_DETAIL_INIT";
export const GET_ALLOCATORS_DETAIL_SUCCESS =
  "ALLOCATOR@GET_ALLOCATORS_DETAIL_SUCCESS";
export const GET_ALLOCATORS_DETAIL_FAILED =
  "ALLOCATOR@GET_ALLOCATORS_DETAIL_FAILED";

export const FOLLOW_ALLOCATOR = "FOLLOW@ALLOCATOR";
export const FOLLOW_ALLOCATOR_INIT = "FOLLOW@ALLOCATOR_INIT";
export const FOLLOW_ALLOCATOR_SUCCESS = "FOLLOW@ALLOCATOR_SUCESS";
export const FOLLOW_ALLOCATOR_FAILED = "FOLLOW@ALLOCATOR_FAILED";

export const CREATE_HEDGEFUND_AUDITLOGS = "FUND@CREATE_HEDGEFUND_AUDITLOGS";
export const CREATE_HEDGEFUND_AUDITLOGS_INIT = "FUND@CREATE_HEDGEFUND_AUDITLOGS_INIT";
export const CREATE_HEDGEFUND_AUDITLOGS_SUCCESS = "FUND@CREATE_HEDGEFUND_AUDITLOGS_SUCCESS";
export const CREATE_HEDGEFUND_AUDITLOGS_FAILED = "FUND@CREATE_HEDGEFUND_AUDITLOGS_FAILED";

export const GET_ALL_ADMIN_LIST = "ALLOCATOR@GET_ALL_ADMIN_LIST";
export const GET_ALL_ADMIN_LIST_INIT = "ALLOCATOR@GET_ALL_ADMIN_LIST_INIT";
export const GET_ALL_ADMIN_LIST_SUCCESS = "ALLOCATOR@GET_ALL_ADMIN_LIST_SUCCESS";
export const GET_ALL_ADMIN_LIST_FAILED = "ALLOCATOR@GET_ALL_ADMIN_LIST_FAILED";

export const GET_ALLOCATOR_USERS = "ALLOCATOR@GET_ALLOCATOR_USERS";
export const GET_ALLOCATOR_USERS_INIT = "ALLOCATOR@GET_ALLOCATOR_USERS_INIT";
export const GET_ALLOCATOR_USERS_SUCCESS = "ALLOCATOR@GET_ALLOCATOR_USERS_SUCCESS";
export const GET_ALLOCATOR_USERS_FAILED = "ALLOCATOR@GET_ALLOCATOR_USERS_FAILED";

export const GET_HEDGEFUND_USERS = "ALLOCATOR@GET_HEDGEFUND_USERS";
export const GET_HEDGEFUND_USERS_INIT = "ALLOCATOR@GET_HEDGEFUND_USERS_INIT";
export const GET_HEDGEFUND_USERS_SUCCESS = "ALLOCATOR@GET_HEDGEFUND_USERS_SUCCESS";
export const GET_HEDGEFUND_USERS_FAILED = "ALLOCATOR@GET_HEDGEFUND_USERS_FAILED";

export const CREATE_APPOINTMENT_ACTION = "ALLOCATOR@CREATE_APPOINTMENT_ACTION";
export const CREATE_APPOINTMENT_REQUEST = "ALLOCATOR@CREATE_APPOINTMENT_REQUEST";
export const CREATE_APPOINTMENT_SUCCESS = "ALLOCATOR@CREATE_APPOINTMENT_SUCCESS";
export const CREATE_APPOINTMENT_FAILED = "ALLOCATOR@CREATE_APPOINTMENT_FAILED";

export const HEDGEFUND_CONNECTION = "ALLOCATOR@HEDGEFUND_CONNECTION";
export const HEDGEFUND_CONNECTION_INIT = "ALLOCATOR@HEDGEFUND_CONNECTION_INIT";
export const HEDGEFUND_CONNECTION_SUCCESS = "ALLOCATOR@HEDGEFUND_CONNECTION_SUCESS";
export const HEDGEFUND_CONNECTION_FAILED = "ALLOCATOR@HEDGEFUND_CONNECTION_FAILED";

export const GET_ALLOCATOR_INFO = "ALLOCATOR@GET_ALLOCATOR_INFO";
export const GET_ALLOCATOR_INFO_INIT = "ALLOCATOR@GET_ALLOCATOR_INFO_INIT";
export const GET_ALLOCATOR_INFO_SUCCESS = "ALLOCATOR@GET_ALLOCATOR_INFO_SUCCESS";
export const GET_ALLOCATOR_INFO_FAILED = "ALLOCATOR@GET_ALLOCATOR_INFO_FAILED";

export const GET_ALLOCATOR_USER_LIST = "ALLOCATOR@GET_ALLOCATOR_USER_LIST";
export const GET_ALLOCATOR_USER_LIST_INIT = "ALLOCATOR@GET_ALLOCATOR_USER_LIST_INIT";
export const GET_ALLOCATOR_USER_LIST_SUCCESS = "ALLOCATOR@GET_ALLOCATOR_USER_LIST_SUCCESS";
export const GET_ALLOCATOR_USER_LIST_FAILED = "ALLOCATOR@GET_ALLOCATOR_USER_LIST_FAILED";